import { createSlice } from "@reduxjs/toolkit";

export const SegmentSlice = createSlice({
  name: "Segment",
  initialState: {
    isLoading: false,
    isError: false,
    data: [],
    error: [],
    message: "",
  },
  reducers: {
    onSegmentSubmit: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        data: [],
        message: "",
      };
    },

    onSegmentSuccess: (state, { payload

    }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: [...state.data, data],
        message,
        status_code
      };
    },

    onSegmentError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        data,
        message,
        status_code,
        isLoading: false,
        isError: true,
      };
    },
    onSegmentReset: (state) => {
      return {
        ...state,
        message:"",
        status_code:null,
        isLoading: false,
        isError: false,
      };
    },
  },
});
export const { onSegmentSubmit, onSegmentSuccess, onSegmentError, onSegmentReset } =
SegmentSlice.actions;

export default SegmentSlice.reducer;
